import { useState, useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";

import { useLayout } from "../../../providers/LayoutProvider";

import MapComponent from "../components/MapComponent";
// import WorkingMap from "../components/WorkingMap";

import { useTalesRepo } from "../db/useTalesRepo";
import { useSegmentsRepo } from "../db/useSegmentsRepo";
import { useTracksRepo } from "../db/useTracksRepo";

import ViewsHeader from "../components/ViewsHeader";
import ViewsFooter from "../components/ViewsFooter";

// import "./map-page.css"; // (tiny styles below)

export default function MapPage() {
  const talesRepo = useTalesRepo();
  const segmentsRepo = useSegmentsRepo();
  const tracksRepo = useTracksRepo();

  // use setters from LayoutProvider to set display and/or set header footer content
  const { setHeaderContent, setFooterContent } = useLayout();
  const { setShowHeader, setShowFooter } = useLayout();
  const [taleSegments, setTaleSegments] = useState([]);
  const [tale, setTale] = useState([]);

  const { taleId } = useParams();

  const [activeFilters, setActiveFilters] = useState({
    transportation: true,
    accommodation: true,
    activity: true,
    tracks: true,
  });

  const handleToggleFilter = (type) => {
    const newState = !activeFilters[type];

    setActiveFilters((prev) => ({
      ...prev,
      [type]: newState,
    }));
  };

  // Mount/unmount header + footer
  useEffect(() => {
    // hide header on this page
    setShowHeader(true);
    // show footer on this page
    setShowFooter(true);

    // Optionally set custom chrome instead:
    setHeaderContent(<ViewsHeader tale={tale} taleId={taleId} />);
    setFooterContent(
      <ViewsFooter
        activeFilters={activeFilters}
        onToggleFilter={handleToggleFilter}
      />
    );

    //set HTML head title
    if (tale.title) document.title = `TOAT - ${tale.title} Timeline`;

    // cleanup runs on unmount, and on dependency changes
    return () => {
      setShowHeader(true);
      setShowFooter(true);
      setHeaderContent(null);
      setFooterContent(null);
    };
  }, [
    tale,
    activeFilters,
    setShowHeader,
    setShowFooter,
    setHeaderContent,
    setFooterContent,
  ]);

  // Load segments and tracks from DB
  useEffect(() => {
    (async () => {
      const tale = await talesRepo.getById(taleId);
      setTale(tale);

      const taleSegments = await segmentsRepo.filterByIndex("taleId", taleId);
      const taleTracks = await tracksRepo.filterByIndex("taleId", taleId);
      const segments = [...taleSegments, ...taleTracks];

      setTaleSegments(segments);
    })();
  }, [taleId, segmentsRepo, talesRepo]);
  //Filter list based on activeFilters
  const filteredSegments = useMemo(() => {
    return taleSegments.filter((seg) => {
      // seg.type should be one of 'transportation', 'accommodation', 'activity', 'tracks'
      const key = seg.type;
      // if we don't recognize the type, just keep it
      if (!(key in activeFilters)) return true;
      return activeFilters[key];
    });
  }, [taleSegments, activeFilters]);

  return (
    <MapComponent
      mapHeight={634}
      view={{ center: [-116.3, 43.6], zoom: 9 }}
      showLines={false}
      segments={filteredSegments}
    />

    // <MapComponent
    //   mapHeight={520} // or 520, etc.
    //   //   view={{ center: [-73.9851, 40.7589], zoom: 11, bearing: 0, pitch: 0 }}
    //   //   markers={[
    //   //     { id: "hotel", name: "Hotel", lng: -73.99, lat: 40.75 },
    //   //     { id: "airport", name: "Airport", lng: -73.87, lat: 40.64 },
    //   //   ]}
    // />
    // <WorkingMap />
  );
}
